export default __webpack_public_path__ + "static/media/09-Joox.104f1b9d.png";